import React, { Component } from 'react';
import { connect } from 'react-redux';
import pretty from 'pretty';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  CodeField,
  InputField,
  required
} from '../../form';

class EmailTemplateTest extends Component {
  onFormSubmit(values) {
    const { dispatch, emailTemplate } = this.props;
    dispatch(setLoader('EmailTemplateTestForm'));
    dispatch(PublisherApi.actions.liveAlertTest.post(emailTemplate.uuid, values, (error, success) => {
      dispatch(removeLoader('EmailTemplateTestForm'));
      if (success) {
        dispatch({
          type: PublisherApi.events.emailTemplate.actionSuccess,
          syncing: false,
          data: { data: { ...success.data } }
        });
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading, pixel } = this.props;
    return (
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >

          <Field
            name='email_template[test_template]'
            label='Paste your email template'
            validate={[required]}
            component={CodeField}
            insertItems={[
              {
                displayText: 'Pixel',
                text: pixel.email_snippet
              }
            ]}
          />
          <br />
          <Field
            name='test_emails'
            label='Enter the recipient emails'
            placeholder='Enter emails separated by comma or one per line'
            component={InputField}
            textarea
            validate={[required]}
          />

          <Button
            type='submit'
            loading={isLoading}
            bsStyle='primary'
          >
            Send Email
          </Button>
        </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'EmailTemplateTestForm',
  enableReinitialize: true
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const { emailTemplate } = ownProps;
  const initialValues = {
    email_template: {
      test_template: pretty(emailTemplate.test_template || '')
    },
    test_emails: ''
  };

  const isLoading = loader.includes('EmailTemplateTestForm');

  return { isLoading, initialValues };
};

export default connect(mapStateToProps)(ResourceForm(EmailTemplateTest));
